import _defineProperty2 from "D:\\Portal_repos\\VE_R2.9\\SWIFMod_CC_Portal_11_4_1\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _get from "@babel/runtime-corejs3/helpers/get";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import constant from "lodash/constant";
import assignWith from "lodash/assignWith";
import memoize from 'memoize-one';
import { intlMessageShape, availableValuesIdDisplayNameObject, DATA_TYPE_OBJECT } from '@jutro/prop-types';
import { messages } from './LookupField.messages';
import { FieldComponent } from '../FieldComponent/FieldComponent';
import { GenericSelectControl } from '../GenericSelectControl/GenericSelectControl';
import { LookupOption as Option } from './components/LookupOption';
import { LookupValue as Value } from './components/LookupValue';
import { LookupDropdownIndicator as DropdownIndicator } from './components/LookupDropdownIndicator';
import { LookupClearIndicator as ClearIndicator } from './components/LookupClearIndicator';
import { LookupControl as Control } from './components/LookupControl';
import { LookupMenu as Menu } from './components/LookupMenu';
import { LookupPlaceholder as Placeholder } from './components/LookupPlaceholder';
import styles from "./LookupField.module.css";
var lookupComponents = {
  Option: Option,
  Value: Value,
  DropdownIndicator: DropdownIndicator,
  ClearIndicator: ClearIndicator,
  Control: Control,
  Menu: Menu,
  Placeholder: Placeholder
};
var shouldCreateNew = function shouldCreateNew(text) {
  return !!text;
};
var FALSE = constant(false);
var getOptionTypesMap = memoize(function () {
  var optionTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return _reduceInstanceProperty(optionTypes).call(optionTypes, function (map, _ref) {
    var type = _ref.type,
      icon = _ref.icon,
      className = _ref.className,
      displayName = _ref.displayName;
    return _Object$assign(map, _defineProperty2({}, type, {
      icon: icon,
      className: className,
      displayName: displayName
    }));
  }, {});
});
var getMergedStyles = memoize(function (internalClassNames) {
  return internalClassNames ? assignWith(_objectSpread({}, styles), internalClassNames, function (lookupFieldStyle, additionalStyle) {
    return additionalStyle ? cx(lookupFieldStyle, additionalStyle) : lookupFieldStyle;
  }) : styles;
});
var LookupOptionShape = PropTypes.shape(_objectSpread({}, availableValuesIdDisplayNameObject, {
  type: PropTypes.string.isRequired
}));
export var LookupField = function (_FieldComponent) {
  _inherits(LookupField, _FieldComponent);
  var _super = _createSuper(LookupField);
  function LookupField() {
    var _this;
    _classCallCheck(this, LookupField);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(_args));
    _defineProperty(_assertThisInitialized(_this), "handleValueChange", function (value) {
      _this.beforeValue = _this.props.value;
      _this.notifyChange(value);
    });
    _defineProperty(_assertThisInitialized(_this), "recent", _this.props.onLoadValues ? [] : _this.props.availableValues);
    _defineProperty(_assertThisInitialized(_this), "state", {
      recent: _this.recent
    });
    _defineProperty(_assertThisInitialized(_this), "loadValues", function (onLoadValues) {
      return function _callee() {
        var _args2 = arguments;
        return _regeneratorRuntime().async(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _regeneratorRuntime().awrap(onLoadValues.apply(void 0, _args2));
              case 2:
                _this.recent = _context2.sent;
                return _context2.abrupt("return", _this.recent);
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, null, null, null, Promise);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "onMenuClose", function () {
      _this.setState({
        recent: _this.recent
      });
    });
    return _this;
  }
  _createClass(LookupField, [{
    key: "renderControlReadOnly",
    value: function renderControlReadOnly(breakpointProps) {
      var id = breakpointProps.id,
        value = breakpointProps.value,
        optionTypes = breakpointProps.optionTypes,
        className = breakpointProps.className;
      var optionTypesMap = getOptionTypesMap(optionTypes);
      var mergedStyles = getMergedStyles(this.props.internalClassNames);
      return value && React.createElement("div", {
        id: id,
        "data-read-only": true,
        className: cx(mergedStyles.lookupField, className)
      }, React.createElement(lookupComponents.Value, {
        data: value,
        selectProps: {
          customStyles: mergedStyles,
          optionTypesMap: optionTypesMap
        }
      }));
    }
  }, {
    key: "renderControl",
    value: function renderControl(breakpointProps, _ref2) {
      var isValid = _ref2.isValid,
        labelId = _ref2.labelId;
      var id = breakpointProps.id,
        availableValues = breakpointProps.availableValues,
        className = breakpointProps.className,
        createNewMessage = breakpointProps.createNewMessage,
        isClearable = breakpointProps.isClearable,
        onLoadValues = breakpointProps.onLoadValues,
        onAddNew = breakpointProps.onAddNew,
        optionTypes = breakpointProps.optionTypes,
        placeholder = breakpointProps.placeholder,
        value = breakpointProps.value,
        disabled = breakpointProps.disabled,
        isInitiallyOpen = breakpointProps.isInitiallyOpen,
        internalClassNames = breakpointProps.internalClassNames;
      var mergedStyles = getMergedStyles(internalClassNames);
      var classes = cx(mergedStyles.lookupField, className);
      var allowNewValue = onAddNew ? shouldCreateNew : FALSE;
      return React.createElement(GenericSelectControl, {
        id: id,
        availableValues: availableValues,
        className: classes,
        components: lookupComponents,
        createNewMessage: createNewMessage,
        defaultOptions: this.state.recent,
        disabled: disabled,
        filter: lookupFilter,
        getOptionValue: getOptionValue,
        getOptionLabel: getOptionLabel,
        isClearable: isClearable,
        allowNewValue: allowNewValue,
        labelId: labelId,
        loadValues: onLoadValues ? this.loadValues(onLoadValues) : undefined,
        onAddNew: onAddNew,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onInputChange: this.onInputChange,
        onMenuClose: this.onMenuClose,
        onValueChange: this.handleValueChange,
        placeholder: placeholder,
        valid: isValid,
        value: value,
        optionTypesMap: getOptionTypesMap(optionTypes),
        customStyles: mergedStyles,
        showRecent: !!onLoadValues,
        isInitiallyOpen: isInitiallyOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _get(_getPrototypeOf(LookupField.prototype), "render", this).call(this);
    }
  }]);
  return LookupField;
}(FieldComponent);
_defineProperty(LookupField, "propTypes", _objectSpread({}, FieldComponent.propTypes, {
  availableValues: PropTypes.arrayOf(LookupOptionShape),
  optionTypes: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    className: PropTypes.string,
    displayName: intlMessageShape.isRequired
  })),
  createNewMessage: intlMessageShape,
  defaultValue: LookupOptionShape,
  isClearable: PropTypes.bool,
  onLoadValues: PropTypes.func,
  onAddNew: PropTypes.func,
  value: LookupOptionShape,
  isInitiallyOpen: PropTypes.bool,
  internalClassNames: PropTypes.object
}));
_defineProperty(LookupField, "defaultProps", _objectSpread({}, FieldComponent.defaultProps, {
  createNewMessage: messages.addItem,
  isClearable: true,
  dataType: DATA_TYPE_OBJECT
}));
function lookupFilter(_ref3, text) {
  var displayName = _ref3.displayName;
  var _context;
  return displayName === null || displayName === void 0 ? void 0 : _includesInstanceProperty(_context = displayName.toLowerCase()).call(_context, text.toLowerCase());
}
function getOptionValue(_ref4) {
  var id = _ref4.id;
  return id;
}
function getOptionLabel(_ref5) {
  var displayName = _ref5.displayName;
  return displayName;
}
LookupField.__docgenInfo = {
  componentName: "LookupField",
  packageName: "@jutro/components",
  description: "",
  displayName: "LookupField",
  methods: [{
    name: "handleValueChange",
    docblock: "handle value change\n@param {object} value",
    modifiers: [],
    params: [{
      name: "value",
      description: null,
      type: {
        name: "object"
      },
      optional: false
    }],
    returns: null,
    description: "handle value change"
  }, {
    name: "renderControlReadOnly",
    docblock: null,
    modifiers: [],
    params: [{
      name: "breakpointProps",
      optional: undefined,
      type: null
    }],
    returns: null
  }, {
    name: "renderControl",
    docblock: null,
    modifiers: [],
    params: [{
      name: "breakpointProps",
      optional: undefined,
      type: null
    }, {
      name: "{ isValid, labelId }",
      optional: undefined,
      type: null
    }],
    returns: null
  }, {
    name: "loadValues",
    docblock: null,
    modifiers: [],
    params: [{
      name: "onLoadValues",
      optional: undefined,
      type: null
    }],
    returns: null
  }, {
    name: "onMenuClose",
    docblock: null,
    modifiers: [],
    params: [],
    returns: null
  }],
  actualName: "LookupField",
  metadataType: "field",
  props: {
    availableValues: {
      type: {
        name: "arrayOf",
        value: {
          name: "custom",
          raw: "LookupOptionShape"
        }
      },
      required: false,
      description: "Array of choice objects to display"
    },
    optionTypes: {
      type: {
        name: "arrayOf",
        value: {
          name: "shape",
          value: {
            type: {
              name: "string",
              required: true
            },
            icon: {
              name: "string",
              required: true
            },
            className: {
              name: "string",
              required: false
            },
            displayName: {
              name: "union",
              required: true,
              value: [{
                name: "string"
              }, {
                name: "shape",
                value: {
                  id: {
                    name: "string",
                    required: false
                  },
                  defaultMessage: {
                    name: "string",
                    required: false
                  },
                  args: {
                    name: "shape",
                    value: {},
                    required: false
                  }
                }
              }]
            }
          }
        }
      },
      required: false,
      description: "Description for available option types"
    },
    createNewMessage: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "The message to display when a new options is being created by the user.",
      defaultValue: {
        value: "messages.addItem",
        computed: true
      }
    },
    defaultValue: {
      type: {
        name: "custom",
        raw: "LookupOptionShape"
      },
      required: false,
      description: "Set the default field value on render if there is a default value; needs onValueChange to work"
    },
    isClearable: {
      type: {
        name: "bool"
      },
      required: false,
      description: "If true ClearIndicator will be shown",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    onLoadValues: {
      type: {
        name: "func"
      },
      required: false,
      description: "Function for asynchronous data loading"
    },
    onAddNew: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback when new items created"
    },
    value: {
      type: {
        name: "custom",
        raw: "LookupOptionShape"
      },
      required: false,
      description: "Value to display in control"
    },
    isInitiallyOpen: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Should dropdown be initially opened"
    },
    internalClassNames: {
      type: {
        name: "object"
      },
      required: false,
      description: "Map of CSS class names for overriding individual parts of component's styles"
    },
    dataType: {
      defaultValue: {
        value: "DATA_TYPE_OBJECT",
        computed: true
      },
      required: false
    }
  },
  composes: ["../FieldComponent/FieldComponent"]
};